module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "noFound"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("暂时找不到您要的数据~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0397159c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData/nodata.vue
// module id = 1155
// module chunks = 1